import React from 'react';
import { motion } from 'framer-motion';

const NavItem = ({ id, label, isActive }) => {
  const handleClick = (e) => {
    e.preventDefault();
    document.getElementById(id).scrollIntoView({
      behavior: 'smooth'
    });
  };

  return (
    <motion.a
      href={`#${id}`}
      className={`nav-item ${isActive ? 'active' : ''}`}
      onClick={handleClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <span className="nav-label">{label}</span>
      {isActive && (
        <motion.div
          className="nav-active-indicator"
          layoutId="activeIndicator"
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 30
          }}
        />
      )}
    </motion.a>
  );
};

export default NavItem; 